const dark = {
  primary: '#2196F3',
  secondary: '#424242',
  accent: '#FF4081',
  success: '#4CAF50',
  error: '#FF5252',
  warning: '#FB8C00',
  info: '#2196F3',
  brightGray: '#EFEFEF',
};

/**
 * Vuetify theme options.
 */
const themes = [
  {
    light: {
      primary: '#42D69E',
      secondary: '#FFFFFF',
      accent: '#82B1FF',
      success: '#4CAF50',
      error: '#FF5252',
      warning: '#FB8C00',
      info: '#2196F3',
      brightGray: '#EFEFEF',
    },
    dark,
  }
];
export default themes;
